import getApi from '../../api/apisauceConfig'
import { deserializeQuestionTemplateResponse } from './mapper/questionTemplates.mapper'
import { QuestionTemplateResource } from './mapper/questionTemplates.model'

export const getQuestionTemplate = (id: number) =>
  getApi()
    .get<QuestionTemplateResource>(`/question_templates/${id}`)
    .then(deserializeQuestionTemplateResponse)
